import { render, staticRenderFns } from "./PlatformPurchaseOrder.vue?vue&type=template&id=7c8f54e1&scoped=true"
import script from "./PlatformPurchaseOrder.vue?vue&type=script&lang=ts"
export * from "./PlatformPurchaseOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f54e1",
  null
  
)

export default component.exports